<script lang="ts">
    import {Component, Vue, Watch} from 'vue-facing-decorator'

    //TODO Need to remove this fucking shit
    @Component
    export class AdditionalSearchOptionsMixin extends Vue {
        selectedCitizenship = null

        @Watch('selectedCitizenship.value')
        onCitizenshipChanged() {
            this.setCurrencyByCitizenship()
        }

        @Watch('defaultCitizenshipId')
        onDefaultCitizenshipId() {
            this.setDefaultCitizenship()
        }

        async mounted() {
            const oldQuery = this.newQuery
            Object.defineProperty(this, 'newQuery', {
                value: () => {
                    const query = oldQuery()
                    const add = this.getAdditionalOptions()
                    return Object.assign(query, add)
                },
            })
            await this.setDefaultCitizenship()
        }

        setCurrencyByCitizenship() {
            const currencyToCountryMap = this.$conf.public.currency.bundledToCountry

            if (!currencyToCountryMap) {
                return
            }

            const countryIdSelected = +this.$conf.public?.searchWithoutDestination?.countryId || +this.city?.countryId
            const citizenshipIdSelected = +this.selectedCitizenship?.value

            let currencyChanged = false

            for (const [currencyCode, countryBundle] of Object.entries(currencyToCountryMap)) {
                const configCountryId = +countryBundle?.countryId
                const configCitizenshipId = +countryBundle?.citizenshipId

                if (configCountryId && configCitizenshipId) {
                    if (configCountryId === countryIdSelected && citizenshipIdSelected === configCitizenshipId) {
                        currencyChanged = true
                        return persistentStore.SET_CURRENCY(currencyCode)
                    }
                } else if (configCountryId || configCitizenshipId) {
                    if (configCountryId === countryIdSelected || citizenshipIdSelected === configCitizenshipId) {
                        currencyChanged = true
                        return persistentStore.SET_CURRENCY(currencyCode)
                    }
                }
            }

            if (!currencyChanged) {
                return persistentStore.SET_CURRENCY(this.$conf.public.currency.default)
            }
        }

        getAdditionalOptions() {
            const form = this.$refs.addForm
            if (form) {
                const params = {}
                for (const key in form.$refs) {
                    const ref = form.$refs[key]
                    if (!ref) continue
                    const {option, altOption} = ref.$refs
                    const el = altOption || option
                    if (el?.name) {
                        params[el.name] =
                            ref.value !== undefined ? (ref.valueName ? ref.valueName : ref.value) : el.value
                    }
                }
                if (this.$refs.additionalOptions?.$refs?.option && this.$refs.additionalOptions?.$refs?.altOption) {
                    const {option, altOption} = this.$refs.additionalOptions.$refs
                    params[option.name] = option.modelValue
                    params[altOption.name] = altOption.modelValue
                }
                const query = Object.fromEntries(
                    Object.entries(params).filter(el => el[1] !== undefined && el[1] !== '')
                )

                //Workaround for GPFE-4983 [prestige]
                if (+(query.transferCategoryCode || query.excursionCategoryCode) === query.productVariantId) {
                    delete query.transferCategoryCode
                    delete query.excursionCategoryCode
                }
                const {transferCategoryCode, excursionCategoryCode, productVariantId} = query
                const categoryCode = transferCategoryCode || excursionCategoryCode
                if (categoryCode && productVariantId) {
                    query.internalSuppliers = true
                    query.externalSuppliers = true
                } else if (productVariantId) {
                    query.externalSuppliers = false
                    query.internalSuppliers = true
                } else if (categoryCode) {
                    query.internalSuppliers = false
                    query.externalSuppliers = true
                }

                return query
            }
            return {}
        }

        changeCitizenship(value) {
            this.selectedCitizenship = {value}
        }

        async setDefaultCitizenship() {
            await this.$store.restored

            if (this.defaultCitizenshipId) {
                this.selectedCitizenship = this.citizenshipItems.find(e => e.value === this.defaultCitizenshipId)
            }
        }

        get defaultCitizenshipId() {
            return authStore.defaultCitizenshipId
        }

        get isCitizenshipMainOption() {
            return this.$conf.public.isCitizenshipMainOption
        }

        get citizenshipItems() {
            return runtimeStore.restrictedCountries.map(({id, name}) => {
                return {
                    name,
                    value: id,
                }
            })
        }
    }

    export default AdditionalSearchOptionsMixin
</script>
